import { createFileRoute } from "@tanstack/react-router";
import { ConnectorExplorer } from "@/components/marketing/home/ConnectorExplorer";
import { GroundUpFlow } from "@/components/marketing/visuals/flow/GroundUpFlow";
import {
  connectorsFlowConfig,
  knowledgeBaseFlowConfig,
  myAppFlowConfig,
} from "@/components/marketing/visuals/flow/flowConfigs";

/**
 * Design iteration playground for the vertical "ground-up" flow heroes.
 * Not linked from anywhere; the production pages render the original
 * visuals. Interactive home variant on top, the three static per-page
 * variants below.
 */
export const Route = createFileRoute("/preview/ground-up-flow")({
  component: function Preview() {
    return (
      <div className="min-h-screen bg-[#070E1A] px-4 py-10">
        <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-2">
          <section className="space-y-3">
            <h2 className="text-sm font-semibold uppercase tracking-widest text-slate-400">
              Home (interactive)
            </h2>
            <div className="max-w-[460px]">
              <ConnectorExplorer />
            </div>
          </section>
          <section className="space-y-3">
            <h2 className="text-sm font-semibold uppercase tracking-widest text-slate-400">
              Connectors
            </h2>
            <div className="max-w-[460px]">
              <GroundUpFlow config={connectorsFlowConfig} />
            </div>
          </section>
          <section className="space-y-3">
            <h2 className="text-sm font-semibold uppercase tracking-widest text-slate-400">
              Knowledge Base
            </h2>
            <div className="max-w-[460px]">
              <GroundUpFlow config={knowledgeBaseFlowConfig} />
            </div>
          </section>
          <section className="space-y-3">
            <h2 className="text-sm font-semibold uppercase tracking-widest text-slate-400">
              MyApp
            </h2>
            <div className="max-w-[460px]">
              <GroundUpFlow config={myAppFlowConfig} />
            </div>
          </section>
        </div>
      </div>
    );
  },
});
